import "./Submissions.module.css";
import Navigation from "@/reusable_sections/Header";
import ArtistApplication from "./sections/ArtistApplication";
import Footer from "@/reusable_sections/Footer";
export default function SubmissionsPage() {
  return <div>
      <Navigation />
      <ArtistApplication />
      <Footer />
    </div>;
}